webpackJsonp([26],{

/***/ "+p4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_share_vue__ = __webpack_require__("O7gi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59971c19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_vue__ = __webpack_require__("fDlu");
function injectStyle (ssrContext) {
  __webpack_require__("CNKx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59971c19"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59971c19_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("LNO7");
__webpack_require__("SCKt");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "1YkC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bear-sitting-on-a-laptop@2x.d4ea11c.png";

/***/ }),

/***/ "3+Gb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "3Xzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_vue__ = __webpack_require__("sQOs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c11a36fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_vue__ = __webpack_require__("biQj");
function injectStyle (ssrContext) {
  __webpack_require__("L00y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c11a36fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c11a36fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "57Hz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/save-time.14c31a9.svg";

/***/ }),

/***/ "AL6B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ByvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'upgraded',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "CNKx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DA9D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app-store-phone.d71d49f.png";

/***/ }),

/***/ "DCoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var LocationService = function () {
  function LocationService() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LocationService);

    this._loadCountry = function () {
      var request = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.ENV.bearsMyIpURL);

      if (_this.ENV.name === 'development') {
        var DEV_COUNTRY = 'RU'; // change to a sanctioned country to test sanction pages
        request = request.catch(function (e) {
          console.warn('Ignoring location request error for local dev and using Canada:', e);
          return { data: { 'countryCode': DEV_COUNTRY, 'countryName': 'Canada', 'region': 'Ontario', 'city': 'Toronto (North York)', 'postalCode': 'M2K', 'latitude': 43.78, 'longitude': -79.4133 } };
        });
      } else if (_this.ENV.name === 'staging') {
        var STAGING_COUNTRY_MAP = {
          'NO': 'RU', // test russia sanction page by connecting via norway on staging
          'CO': 'BY' // test belarus sanction page via colombia
        };
        request = request.then(function (response) {
          if (response.data.countryCode in STAGING_COUNTRY_MAP) {
            response.data.countryCode = STAGING_COUNTRY_MAP[response.data.countryCode];
          }
          return response;
        });
      }

      return request.then(function (response) {
        return response.data.countryCode;
      }, function (requestError) {
        _this.countryIso = null; // clear out rejected promise so next getCountryCode will retry
        console.log('Failed to load location', requestError);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('Failed to load location'));
      });
    };

    this.ENV = __webpack_require__.i({"name":"production","baseURL":"https://www.remembear.com","blogURL":"https://www.remembear.com/blog","apiBaseUrl":"https://www.remembear.com/api","paymentBaseUrl":"https://www.remembear.com/payment/v2","bearsMyIpURL":"https://www.remembear.com/bearsmyip/location","stripeKey":"pk_live_v4RHNCjHGeDZYZBvpqEUSq5u"});
    this.countryIso = null; // null: not started, otherwise a promise that will resolve to the 2-letter country code
    this.sanctionedCountries = [// we offer bandwidth since we can't sell there any more
    'RU', // russia
    'BY' // belarus
    ];
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LocationService, [{
    key: 'isSanctioned',
    value: function isSanctioned() {
      var _this2 = this;

      return this.getCountryCode().then(function (iso) {
        return _this2.sanctionedCountries.includes(iso);
      });
    }
  }, {
    key: 'getCountryCode',
    value: function getCountryCode() {
      if (this.countryIso === null) {
        this.countryIso = this._loadCountry();
      }
      return this.countryIso;
    }
  }]);

  return LocationService;
}();



/***/ }),

/***/ "E+qO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FU/X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GCFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bg-dark-blue",attrs:{"id":"app-of-the-day"}},[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('img',{staticClass:"app-store",attrs:{"srcset":__webpack_require__("DA9D") + ' 1x,' + __webpack_require__("bJCX") + ' 2x',"src":__webpack_require__("bJCX"),"alt":""}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy"},[_c('img',{staticClass:"app-of-the-day",attrs:{"src":__webpack_require__("h0wn"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("\"RememBear is a password manager - but with bear puns. As in, ensuring you have the bear minimum of work to do in remembering your passwords, while keeping them ultra-safe. What’s not to love?\"")]),_vm._v(" "),_c('p',{staticClass:"small-copy"},[_vm._v("App Store feature")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HE+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upgraded_vue__ = __webpack_require__("ByvB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44a09d51_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upgraded_vue__ = __webpack_require__("tm+N");
function injectStyle (ssrContext) {
  __webpack_require__("FU/X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44a09d51"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upgraded_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44a09d51_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upgraded_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Igq2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./screenshots-windows.png": "X2R+",
	"./screenshots-windows@2x.png": "Jj1a"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Igq2";

/***/ }),

/***/ "JQLz":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Jj1a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-windows@2x.546177e.png";

/***/ }),

/***/ "KJxS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-mac@2x.b67832e.png";

/***/ }),

/***/ "L00y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1518e69f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qnTj");
function injectStyle (ssrContext) {
  __webpack_require__("nYrJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1518e69f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_locationData_json__ = __webpack_require__("jUxj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_locationData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_locationData_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm__ = __webpack_require__("Sl4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_meta_json__ = __webpack_require__("byxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_meta_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_meta_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_7_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_gtm___default.a, {
  id:  true ? 'GTM-NCP9CN5' : 'GTM-5JMH4BW',
  enabled: window.location.host.indexOf('remembear.com') > -1, // disabled for prerender-spa-plugin
  debug: false
  // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      ENV: __webpack_require__.i({"name":"production","baseURL":"https://www.remembear.com","blogURL":"https://www.remembear.com/blog","apiBaseUrl":"https://www.remembear.com/api","paymentBaseUrl":"https://www.remembear.com/payment/v2","bearsMyIpURL":"https://www.remembear.com/bearsmyip/location","stripeKey":"pk_live_v4RHNCjHGeDZYZBvpqEUSq5u"}),
      locations: __WEBPACK_IMPORTED_MODULE_3__data_locationData_json___default.a,
      external: {
        twitterUrl: 'https://www.twitter.com/remembear',
        facebookUrl: 'https://www.facebook.com/RememBearApp',
        instagramUrl: 'https://www.instagram.com/TunnelBear',
        help: 'https://help.remembear.com',
        downloadLinks: {
          windows64: 'https://s3.amazonaws.com/remembear/app/release/downloads/windows/RememBear_x64.exe',
          windows32: 'https://s3.amazonaws.com/remembear/app/release/downloads/windows/RememBear_x86.exe',
          mac: 'https://remembear.s3.amazonaws.com/app/release/downloads/macOS/RememBear.dmg',
          ios: 'https://itunes.apple.com/app/remembear-password-manager/id1145554431',
          android: 'https://play.google.com/store/apps/details?id=com.remembear.android',
          chrome: 'https://chrome.google.com/webstore/detail/remembear/ehpbfbahieociaeckccnklpdcmfaeegd',
          safari: 'https://remembear.s3.amazonaws.com/app/release/downloads/macOS/RememBear.dmg', // same as mac
          firefox: 'https://addons.mozilla.org/en-US/firefox/addon/remembear-app/'
        }
      }
    };
  }
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_6__data_meta_json___default.a[to.name]) {
    document.title = __WEBPACK_IMPORTED_MODULE_6__data_meta_json___default.a[to.name].title;
  } else {
    document.title = __WEBPACK_IMPORTED_MODULE_6__data_meta_json___default.a.default.title;
  }

  if (to.path.slice(-1) === '/' && to.path.length > 1) {
    var pathWithoutSlash = to.path.substring(0, to.path.length - 1);
    next({ path: pathWithoutSlash, query: to.query, hash: to.hash, meta: to.meta, params: to.params });
    return;
  } else if (to.name === 'login' && __WEBPACK_IMPORTED_MODULE_4__store_js__["a" /* default */].getters.isLoggedIn) {
    next({ name: 'overview' });
    return;
  } else if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_4__store_js__["a" /* default */].getters.isLoggedIn) {
      if (to.name === 'upgrade' && to.query.token) {
        next();
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_4__store_js__["a" /* default */].commit('saveNextRoute', to);
        next({
          name: 'login'
        });
        return;
      }
    }
  }
  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store_js__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  }
});

/***/ }),

/***/ "NTC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site-footer',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ "O7gi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacyPolicy',
  data: function data() {
    return {};
  },

  created: function created() {
    if (!this.$route.name) {
      this.$router.push({ name: 'home' });
    }
  }
});

/***/ }),

/***/ "Rqlq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Rt+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'img-text',
  props: ['img', 'txt', 'rawHtml', 'title', 'imgWidth', 'layout', 'ctaCopy', 'ctaLink', 'classes'],
  methods: {
    getSrc: function getSrc(value) {
      var src = __webpack_require__("sRL0")("./" + value);
      return src;
    }
  }
});

/***/ }),

/***/ "SFkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js__ = __webpack_require__("MMt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_img_text_img_text__ = __webpack_require__("vl9m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_of_the_day_app_of_the_day__ = __webpack_require__("bjk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_is_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_services_js__ = __webpack_require__("TZir");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    'img-text': __WEBPACK_IMPORTED_MODULE_1__components_img_text_img_text__["a" /* default */],
    'app-of-the-day': __WEBPACK_IMPORTED_MODULE_2__components_app_of_the_day_app_of_the_day__["a" /* default */]
  },
  data: function data() {
    return {
      is: __WEBPACK_IMPORTED_MODULE_3_is_js___default.a,
      animaton: {},
      animationFailed: false,
      animationLoaded: false,
      fallback: false,
      images: 0,
      learnMore: {
        private: false,
        openInternet: false
      },
      platforms: ['mac', 'windows', 'ios', 'android'],
      productDemo: 'mac',
      stepsIn: false,
      screenshots: [],
      lazyLoad: false
    };
  },

  created: function created() {
    this.productDemo = __WEBPACK_IMPORTED_MODULE_3_is_js___default.a.mac() ? 'mac' : 'windows';
  },
  computed: {
    isApple: function isApple() {
      return __WEBPACK_IMPORTED_MODULE_3_is_js___default.a.mac() || __WEBPACK_IMPORTED_MODULE_3_is_js___default.a.ios();
    },
    deviceName: function deviceName() {
      var device = 'Mac';
      if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.windows()) {
        device = 'PC';
      } else if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.ios()) {
        device = 'iPhone';
      } else if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.ipad()) {
        device = 'iPad';
      } else if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.android()) {
        device = 'Android';
      }
      return device;
    }
  },
  beforeMount: function beforeMount() {
    this.$emit('modifyLayout', {
      bgColor: 'bg-blue'
    });
    this.loadAnimationImgs();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.lazyLoad = true;
      this.loadScreenshotImgs();
    });
  },

  methods: {
    loadScreenshotImgs: function loadScreenshotImgs() {
      var _this = this;

      var size = '';
      if (window.devicePixelRatio > 1) {
        size = '@2x';
      }
      var imgs = [__webpack_require__("loLo")("./screenshots-mac" + size + '.png'), __webpack_require__("tAFp")("./screenshots-ios" + size + '.png'), __webpack_require__("Igq2")("./screenshots-windows" + size + '.png'), __webpack_require__("bvpt")("./screenshots-android" + size + '.png')];
      __WEBPACK_IMPORTED_MODULE_4__services_services_js__["a" /* default */].preloadImages(imgs).then(function (loadedImgs) {
        _this.screenshots = loadedImgs;
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.animation.removeEventListener('complete');
    this.animation.removeEventListener('data_failed');
  }
});

/***/ }),

/***/ "SFnC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/easily-access-credit-cards.c3b8540.svg";

/***/ }),

/***/ "TZir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);


/* harmony default export */ __webpack_exports__["a"] = ({
  windowScrollTop: function windowScrollTop() {
    return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  },
  preloadImages: function preloadImages(imgSrcs) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      var images = [];
      var promises = [];

      for (var i = 0; i < imgSrcs.length; i++) {
        promises[i] = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          images[i] = new Image();
          images[i].addEventListener('load', function handler() {
            this.removeEventListener('load', handler);
            resolve();
          });
          images[i].src = imgSrcs[i];
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        resolve(images);
      });
    });
  },
  urlEncodeData: function urlEncodeData(data) {
    var buffer = [];
    for (var key in data) {
      if (!data.hasOwnProperty(key)) continue;
      var encodedKey = encodeURIComponent(key);
      var encodedValue = encodeURIComponent(data[key]);
      buffer.push(encodedKey + '=' + encodedValue);
    }
    buffer = buffer.join('&');
    return buffer;
  },
  formatDate: function formatDate(date, shortForm) {
    var dateObj = new Date(date);

    if (!(dateObj instanceof Date && isFinite(dateObj))) return '';
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (shortForm) {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    }
    var dateStr = months[dateObj.getMonth()] + ' ' + dateObj.getDate() + ', ' + dateObj.getFullYear();
    return dateStr;
  },
  objIsEmpty: function objIsEmpty(obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).length === 0 && obj.constructor === Object;
  }
});

/***/ }),

/***/ "Tacz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/upgrade-success.c9cba51.svg";

/***/ }),

/***/ "VGxG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WNUp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sunset-visual.5ad0ec6.png";

/***/ }),

/***/ "WQ2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-of-the-day',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "X2R+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-windows.fbfd77a.png";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_home__ = __webpack_require__("zKIK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_download_download__ = __webpack_require__("pd/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_share_share__ = __webpack_require__("+p4z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_share__ = __webpack_require__("ZysX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_upgraded_upgraded__ = __webpack_require__("HE+l");








var privacyPolicy = function privacyPolicy() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "OsBv"));
};
var autorenewPolicy = function autorenewPolicy() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "0wQv"));
};
var notices = function notices() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "tGQv"));
};
var termsOfService = function termsOfService() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "ruoz"));
};

var account = function account() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "B64m"));
};
var launch = function launch() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "Dzob"));
};
var overview = function overview() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "3C4T"));
};
var billing = function billing() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "eKmp"));
};
var privacy = function privacy() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "vW45"));
};
var redeem = function redeem() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "AQwS"));
};
var redeemPortal = function redeemPortal() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "5zAK"));
};
var redeemCoupon = function redeemCoupon() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "c7Wh"));
};
var redeemDownload = function redeemDownload() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "kQXS"));
};
var downgraded = function downgraded() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "Lh5Q"));
};
var browsers = function browsers() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "33Pt"));
};
var openApp = function openApp() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "9HXu"));
};
var login = function login() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "W2Q3"));
};
var selfDelete = function selfDelete() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "EKaA"));
};
var deleted = function deleted() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "FPN+"));
};
var deletedFailed = function deletedFailed() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "TtR/"));
};
var deletedSuccess = function deletedSuccess() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "8Q0I"));
};
var itemShare = function itemShare() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "npJZ"));
};
var purchaseSuccess = function purchaseSuccess() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "I0S2"));
};
var staySafe = function staySafe() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "X6W4"));
};

var support = function support() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "1K9X"));
};

// restricted


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_home__["a" /* default */]
  }, {
    path: '/download',
    name: 'download',
    component: __WEBPACK_IMPORTED_MODULE_3__views_download_download__["a" /* default */]
  }, {
    path: '/pricing',
    name: 'pricing',
    redirect: { name: 'home' }
  }, {
    path: '/try',
    name: 'try',
    redirect: { name: 'home' }
  }, {
    path: '/login',
    name: 'login',
    component: login
  }, {
    path: '/download/browsers',
    alias: '/download/browser',
    name: 'browsers',
    component: browsers
  }, {
    path: '/support',
    name: 'support',
    component: support
  }, {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: termsOfService
  }, {
    path: '/autorenew-policy',
    name: 'autorenew-policy',
    component: autorenewPolicy
  }, {
    path: '/privacy-notice',
    alias: '/privacy-policy',
    name: 'privacy-policy',
    component: privacyPolicy
  }, {
    path: '/notices',
    name: 'notices',
    component: notices
  }, {
    path: '/upgraded',
    name: 'upgraded',
    component: __WEBPACK_IMPORTED_MODULE_6__views_upgraded_upgraded__["a" /* default */]
  }, {
    path: '/downgraded',
    name: 'downgraded',
    component: downgraded
  }, {
    path: '/checkout',
    name: 'checkout',
    redirect: { name: 'home' }
  }, {
    path: '/purchase-success',
    name: 'purchase-success',
    component: purchaseSuccess
  }, {
    path: '/stay-safe',
    name: 'stay-safe',
    component: staySafe
  },
  // restricted views
  {
    path: '/account',
    component: account,
    meta: { requiresAuth: true },
    children: [{
      path: '',
      name: 'overview',
      component: overview,
      meta: { requiresAuth: true,
        noScroll: true }
    }, {
      path: 'update',
      name: 'update',
      component: overview,
      meta: { requiresAuth: true,
        noScroll: true }
    }, {
      path: 'billing',
      name: 'billing',
      component: billing,
      meta: { requiresAuth: true,
        noScroll: true }
    }, {
      path: 'privacy',
      name: 'privacy',
      component: privacy,
      meta: { requiresAuth: true,
        noScroll: true }
    }, {
      path: '*',
      redirect: { name: 'overview' }
    }]
  }, {
    path: '/redeem',
    name: 'redeem',
    component: redeem,
    children: [{
      path: 'welcome',
      name: 'redeem-portal',
      component: redeemPortal
    }, {
      path: 'coupon',
      name: 'redeem-coupon',
      component: redeemCoupon
    }, {
      path: 'download',
      name: 'redeem-download',
      component: redeemDownload
    }],
    beforeEnter: function beforeEnter(to, from, next) {
      if (to.path === '/redeem') {
        next({ replace: true, name: 'redeem-portal', query: to.query, hash: to.hash });
      } else {
        next();
      }
    }
  }, {
    path: '/downgrade',
    name: 'downgrade',
    redirect: { name: 'home' }
  }, {
    path: '/delete',
    name: 'delete',
    component: selfDelete
  }, {
    path: '/upgrade',
    name: 'upgrade',
    redirect: { name: 'home' }
  }, {
    path: '/deleted',
    component: deleted,
    children: [{
      path: '/',
      name: 'deleted-success',
      component: deletedSuccess
    }, {
      path: 'failed',
      name: 'deleted-fail',
      component: deletedFailed
    }]
  }, {
    path: '/share',
    component: __WEBPACK_IMPORTED_MODULE_4__views_share_share__["a" /* default */],
    children: __WEBPACK_IMPORTED_MODULE_5__mixins_share__["a" /* default */].routes
  }, {
    path: '/launch',
    name: 'launch',
    component: launch
  }, {
    path: '/item-share',
    name: 'item-share',
    component: itemShare
  }, {
    path: '/open-app',
    name: 'open-app',
    component: openApp
  }, {
    path: '/tos',
    redirect: '/terms-of-service'
  }, {
    path: '*',
    redirect: { name: 'home' }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.meta.noScroll) return;
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ "ZWju":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sunset-visual@2x.cfdce5f.png";

/***/ }),

/***/ "ZysX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  routes: [{
    path: 'android-autofill',
    name: 'androidAutofillEnabled'
  }, {
    path: 'macos-credit-card',
    name: 'creditCardAddedMacOS'
  }, {
    path: 'windows-credit-card',
    name: 'creditCardAddedWindows'
  }, {
    path: 'ios-safari-extension',
    name: 'iosSafariExtensionAdded'
  }, {
    path: 'macos-browser-extension',
    name: 'macosBrowserExtensionAdded'
  }, {
    path: 'import-macos-items',
    name: 'macosImportItems'
  }, {
    path: 'ios-autofill-enabled',
    name: 'iosAutofillEnabled'
  }, {
    path: 'new-android-device',
    name: 'newDeviceAddedAndroid'
  }, {
    path: 'new-ios-device',
    name: 'newDeviceAddediOS'
  }, {
    path: 'new-macos-device',
    name: 'newDeviceAddedMacOS'
  }, {
    path: 'new-windows-device',
    name: 'newDeviceAddedWindows'
  }, {
    path: 'strong-master-password',
    name: 'strongMasterPassword'
  }, {
    path: 'windows-browser-extension',
    name: 'windowsBrowserExtensionAdded'
  }, {
    path: 'import-windows-items',
    name: 'windowsImportItems'
  }, {
    path: 'account-upgrade',
    name: 'accountUpgrade'
  }, {
    path: 'share-a-bear',
    name: 'shareABear'
  }, {
    path: 'secure-note-added',
    name: 'secureNoteAdded'
  }, {
    path: '*',
    redirect: { name: 'home' }
  }]
});

/***/ }),

/***/ "aMNx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxODIgMjIiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMCAwaDE4MnYyMkgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM0MzRENUIiIGQ9Ik0xNTUuMDE4IDE5LjIyM2MtLjk3OCAwLTMuMDI2LS4wMzItMi40NDUtMS45NTdsMS4wMzktMy41OTloMy4zbC0xLjg5NCA1LjU1NnptMjAuNTIzIDBsMi43Mi04LjAxOGgtOC4yNWwxLjI1Mi0zLjc1NmgtMi40MTRjLTIuMDc4IDAtNC43NjcuOTQ3LTQuNzY3IDMuNTM1IDAgMS4yOTQuODU2IDIuNCAyLjA3OCAyLjY4M2wtMS45NTYgNS41NTZoLTMuODdsMi44MTMtOC4wMThoLTguNTI2Yy0zLjk0MyAwLTcuNzMyIDIuMjQtNy43MzIgNi43ODYgMCAuNDM4LjA1NS44NS4xNTggMS4yMzJoLTguOTJjLS44ODUgMC0yLjMyMS0uMjg0LTEuODMzLTEuODMxbDEuMjIyLTMuNzI1aDMuMTQ4bC0xLjYyIDMuMzE1aDQuOTUxYy44ODYtLjYgMS41OS0xLjQ4NCAxLjUyOC0yLjc0Ni0uMTIyLTIuNDMxLTMuNDIzLTMuMDMtNS4zMTctMy4wM2gtMi4xN2MtMy40NTMgMC03LjU0NyAxLjc5OS03LjU0NyA1Ljk2NSAwIDMuOTE0IDQuMzM5IDQuNTEzIDcuMjQxIDQuNTEzaDguMzEyYy43NiAwIDEuNTQtLjE4MiAyLjE5OS0uNTU0LjY2NC41NTQgMS41NDEuODcgMi41Ni44NyAxLjU1OCAwIDIuOTk0LS43MjYgNC4wMDMtMS45MjUgMCAxLjMyNSAxLjQwNSAxLjYxIDIuNDE0IDEuNjFoNi4yNThjMS43NiAwIDMuMDk3LS41OTMgMy42NTUtMi40MjRsMi4xMTUtNS41OTRoMy4xNzhsLTEuNjggNS4wMTljLS41NSAxLjcwNC4xNTMgMi45OTggMi4wNzcgMi45OThoNS43MTVjMS4yODMgMCAzLjI3LS45MTUgMy4yNy0yLjQ2MWgtNi4yNjV6TTEzNC43NzcgNC44NmMwLTMuOTE0LTMuMTgtNC44NjEtNy4yNDMtNC44NjFoLTE3LjQxOGwtMi4yOTIgMy44ODNoMTcuNDQ5YzEuNTU4IDAgMy41MTQuNDEgMy41MTQgMi4zNjcgMCAyLjU1Ni0yLjQ0NCAzLjgxOS00LjEyNSA0LjY0LS43MDMuMzQ3LTEuMjg0LjUzNi0xLjYyIDEuMzI2LS4wMy4wOTQtLjAzLjIyLS4wMy4zMTUgMCAuOTQ3IDEuMTkyIDEuNzM2IDEuMTkyIDIuOTk5IDAgMy4yNS00Ljc2OCAzLjY5My03LjA5IDMuNjkzaC0uNzY0bDQuNTgzLTEzLjM1MmgtNS4zNzhsLTQuNTQgMTMuMzUyaC01LjA4M2wxLjkyNS01LjU1NmMuNTItMS41MTUuMjQ1LTIuODcyLTEuNjUtMi44NzItMS42OCAwLTIuNjU5LjYtMy42MDYgMS40Mkw5OC4xNCAxNi4xM2wxLjA3LTMuMDYyYy42NDItMS44LS42NDEtMi4yNzMtMS41ODktMi4yNzMtMS44MzMgMC0yLjkwMy42NjMtMy44NSAxLjQ1MmwtNC41ODQgMy44ODMgMS42ODEtNC45MjVoLTUuMzc4bC0yLjczNiA4LjAxOGgtOC44NGMtLjg4NSAwLTIuMzIyLS4yODQtMS44MzMtMS44MzFsMS4yMjMtMy43MjVoMy4xNDdsLTEuNjIgMy4zMTVoNC45NWMuODg3LS42IDEuNTktMS40ODQgMS41MjktMi43NDYtLjEyMi0yLjQzMS0zLjQyMy0zLjAzLTUuMzE3LTMuMDNoLTIuMTdjLTMuNDUzIDAtNy41NDggMS43OTktNy41NDggNS45NjUgMCAuODI1LjIwMSAxLjQ5Ni41MzMgMi4wNTJoLTQuNjM5bDEuOTI1LTUuNTU2Yy41Mi0xLjUxNS4yNDUtMi44NzItMS42NS0yLjg3Mi0xLjY4IDAtMi42NTguNi0zLjYwNiAxLjQybC00LjQ2MSAzLjkxNSAxLjA3LTMuMDYyYy42NDEtMS44LS42NDItMi4yNzMtMS41OS0yLjI3My0xLjgzMyAwLTIuOTAzLjY2My0zLjg1IDEuNDUybC00LjU4NCAzLjg4MyAxLjY4MS00LjkyNWgtNS4zNzhsLTIuNzM1IDguMDE4aC04LjYzMmMtLjg4NiAwLTIuMzIyLS4yODQtMS44MzMtMS44MzFsMS4yMjItMy43MjVoMy4xNDhsLTEuNjIgMy4zMTVoNC45NWMuODg3LS42IDEuNTktMS40ODQgMS41MjgtMi43NDYtLjEyMi0yLjQzMS0zLjQyMi0zLjAzLTUuMzE3LTMuMDNoLTIuMTdjLTMuNDUyIDAtNy41NDcgMS43OTktNy41NDcgNS45NjUgMCAuODI1LjIwMSAxLjQ5Ni41MzMgMi4wNTJIMTkuNzFsLTIuNjktNS45OThjMi45OTUtMS4yIDguNDM1LTMuODE5IDguNDM1LTcuODlDMjUuNDU1LjYgMjAuNDQzIDAgMTcuMzU3IDBIMi4zMjJMMCAzLjg4M2gxNS4yMTdjMS43NzMgMCAzLjc2LjUwNSAzLjc2IDIuNzQ2IDAgMS43MzYtMS4yMjMgMy4wNjEtMi45NjUgMy45NzYtLjYxLjM0OC00LjIxNyAxLjczNy00Ljk4IDEuODk0bDIuOTMzIDYuNzI0Yy42NzIgMS41NzcgMS4wNyAyLjQ2MSAyLjgxMSAyLjQ2MWg1LjQ2N2MuOTI4IDAgMS45MTctLjM0NCAyLjUyOC0xLjAzIDEuNTEuODQzIDMuNTcyIDEuMDMgNS4xOSAxLjAzaDExLjI0NGMuNzM0IDAgMS4zNDUtLjE4OSAxLjg5NS0uNjYybDUuOTI4LTUuMTE0Yy0uMzM2Ljk3OC0xLjE5MiAzLjMxNS0xLjE5MiAzLjMxNS0uMzk3IDEuMDczLS40ODggMi42ODIgMS44MDMgMi42ODIgMS40OTggMCAyLjUwNi0uOTc4IDMuMjctMS42NDFsNS4wNDItNC4zNTZjLS4zMzYgMS4wMS0uOTc4IDMuMzE1LS45NzggMy4zMTUtLjM2NiAxLjIzLjc5NSAyLjQ2MSAxLjg2NCAyLjQ2MWg2LjU4NGMxLjA4NSAwIDIuMTI3LS4zMzkgMi43NzYtMS4xMDcgMS41Mi45MDcgMy42NTUgMS4xMDcgNS4zMiAxLjEwN2g4LjMxMmwuMDg1LS4wMDJ2LjAwMmgzLjA1NWMuNzM0IDAgMS4zNDUtLjE4OSAxLjg5NC0uNjYybDUuOTI5LTUuMTE0Yy0uMzM2Ljk3OC0xLjE5MiAzLjMxNS0xLjE5MiAzLjMxNS0uMzk3IDEuMDczLS40ODkgMi42ODIgMS44MDQgMi42ODIgMS40OTcgMCAyLjUwNS0uOTc4IDMuMjY5LTEuNjQxbDUuMDQyLTQuMzU2Yy0uMzM2IDEuMDEtLjk3OCAzLjMxNS0uOTc4IDMuMzE1LS4zNjcgMS4yMy43OTQgMi40NjEgMS44NjQgMi40NjFoMTUuMzM4YzMuNzkgMCAxMS40NTktMS4wNCAxMS40NTktNi4yNDkgMC0xLjMyNi0uNTItMi41ODgtMS4xNjEtMy43MjUgMi41NjctMS4yOTQgNi41NC0zLjQwOCA2LjU0LTYuODQ5ek03LjczIDUuODcxTDIuMzIyIDIxLjY4NGg1LjM3OUwxMy4xNCA1Ljg3MUg3LjczMXoiLz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "bJCX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app-store-phone@2x.482125a.png";

/***/ }),

/***/ "biQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nav-wrap",class:{'scrolled': _vm.scrolled }},[_c('nav',{attrs:{"id":"main-header"}},[_c('div',{staticClass:"nav-inner clearfix complex"},[_c('div',{staticClass:"top-bar"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'home'}}},[_c('img',{staticClass:"hidden-sm",attrs:{"src":__webpack_require__("aMNx"),"alt":"RememBear Home"}}),_vm._v(" "),_c('img',{staticClass:"visible-sm",attrs:{"src":__webpack_require__("jSpy"),"alt":"RememBear Home"}})]),_vm._v(" "),_c('button',{staticClass:"menu visible-sm",on:{"click":function($event){_vm.menuVisible = !_vm.menuVisible}}},[_vm._v("Menu")])],1),_vm._v(" "),_c('div',{staticClass:"list",class:{'mobile-visible': _vm.menuVisible},attrs:{"id":"nav-items"}},[_c('div',{staticClass:"nav-state PUBLIC"},[_c('ul',[_vm._m(0),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.ENV.blogURL}},[_vm._v("Blog")])])])])])]),_vm._v(" "),_c('div',{staticClass:"nav-inner minimal"},[_c('div',{staticClass:"top-bar"},[_c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'home'}}},[_c('img',{attrs:{"src":__webpack_require__("aMNx"),"alt":"RememBear Beta Home"}})])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://help.remembear.com"}},[_vm._v("Help")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bjk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_of_the_day_vue__ = __webpack_require__("WQ2W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1545684f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_of_the_day_vue__ = __webpack_require__("GCFH");
function injectStyle (ssrContext) {
  __webpack_require__("f6gU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1545684f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_of_the_day_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1545684f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_of_the_day_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bvpt":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./screenshots-android.png": "qZDG",
	"./screenshots-android@2x.png": "g/k9"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bvpt";

/***/ }),

/***/ "byxO":
/***/ (function(module, exports) {

module.exports = {"default":{"title":"The easiest way to remember passwords | RememBear"},"home":{"card":"app","title":"RememBear: The easiest way to remember passwords","tw_title":"","image":"/static/images/social-meta/share_graphic.png","description":"Secure and remember all your passwords with RememBear. A simple app that stores your passwords securely, and types them in right when you need them."},"try":{"card":"summary","title":"RememBear: The easiest way to remember passwords","tw_title":"","image":"/static/images/social-meta/share_graphic.png","description":"Secure and remember all your passwords with RememBear. A simple app that stores your passwords securely, and types them in right when you need them."},"download":{"card":"app","title":"Download a RememBear | RememBear","tw_title":"Download a RememBear","image":"/static/images/social-meta/share_graphic.png","description":"Download RememBear, a simple app that stores your passwords securely, and types them in right when you need them. Available for macOS, Windows, iOS, and Android."},"checkout":{"card":"app","title":"Purchase RememBear | RememBear","tw_title":"Purchase RememBear","image":"/static/images/social-meta/share_graphic.png","description":"Get RememBear Premium"},"upgrade":{"card":"app","title":"Purchase RememBear | RememBear","tw_title":"Purchase RememBear","image":"/static/images/social-meta/share_graphic.png","description":"Get RememBear Premium"},"support":{"card":"summary_large_image","title":"Contact a Support Bear | RememBear","tw_title":"Contact a Support Bear","image":"/static/images/social-meta/share_graphic.png","description":"Want to get in touch with a Support Bear?"},"pricing":{"card":"summary_large_image","title":"Choose your Bear | RememBear","tw_title":"Choose your Bear","image":"/static/images/social_meta/share_graphic.png","description":"Upgrrrade to RememBear Premium for sync across unlimited devices, secure backup, and priority customer service."},"privacy-notice":{"card":"summary_large_image","title":"Privacy Notice | RememBear","tw_title":"RememBear Privacy Notice","image":"/static/images/social-meta/share_graphic.png","description":"Read our simple privacy notice for a breakdown of how we carefully handle data and protect your privacy."},"terms-of-service":{"card":"summary_large_image","title":"Terms of Service | RememBear","tw_title":"RememBear Terms of Service","image":"/static/images/social-meta/share_graphic.png","description":"Read our simple Terms of Service which details your agreement with RememBear apps and website. "},"notices":{"card":"summary_large_image","title":"RememBear Legal Notices & Open Source Attribution | RememBear","tw_title":"RememBear Legal Notices & Open Source Attribution","image":"/static/images/social-meta/share_graphic.png","description":"RememBear utilizes the following open source projects without modification unless otherwise noted and linked."},"androidAutofillEnabled":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/androidAutofillEnabled.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"creditCardAddedMacOS":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/creditCardAddedMacOS.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"creditCardAddedWindows":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/creditCardAddedWindows.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"iosSafariExtensionAdded":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/iosSafariExtensionAdded.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"macosBrowserExtensionAdded":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/macosBrowserExtensionAdded.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"macosImportItems":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/macosImportItems.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"iosAutofillEnabled":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/iosAutofillEnabled.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"newDeviceAddedAndroid":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/newDeviceAddedAndroid.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"newDeviceAddediOS":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/newDeviceAddediOS.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"newDeviceAddedMacOS":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/newDeviceAddedMacOS.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"newDeviceAddedWindows":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/newDeviceAddedWindows.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"strongMasterPassword":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/strongMasterPassword.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"windowsBrowserExtensionAdded":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/windowsBrowserExtensionAdded.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"windowsImportItems":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/windowsImportItems.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"accountUpgrade":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/accountUpgrade.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"secureNoteAdded":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/secureNoteAdded.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"shareABear":{"card":"summary_large_image","title":"You've Discovered an Achievement Bear!","tw_title":"","image":"/static/images/social-gifs/shareABear.gif","description":"Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear."},"item-share":{"card":"summary_large_image","title":"Securely shared password - will self-destruct!","tw_title":"Someone shared a password with you","image":"/static/images/social_meta/share_graphic.png","description":"A password has been shared securely with you. It will self-destruct after viewing or in 48 hours, whichever comes first."},"password-check":{"card":"summary_large_image","title":"Remembear: Password Test","tw_title":"","image":"/static/images/social-meta/share_graphic.png","description":"Since 2007, hackers have stolen passwords and personal data from over 400 popular websites. This safe, free test will tell you which of your accounts were affected (and what to do next)."}}

/***/ }),

/***/ "cmBX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crmo":
/***/ (function(module, exports) {

module.exports = {"REMEMBEAR_MONTHLY":{"chargePrice":"6.00","regularPrice":"6.00"},"REMEMBEAR_YEARLY":{"chargePrice":"36.00","regularPrice":"36.00"},"REMEMBEAR_TWO_YEAR_PAYMENT":{"chargePrice":"60.00","regularPrice":"60.00"},"REMEMBEAR_THREE_YEAR_PAYMENT":{"chargePrice":"63.00","regularPrice":"63.00"}}

/***/ }),

/***/ "d5hg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-ios@2x.9c3a99b.png";

/***/ }),

/***/ "dQCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("NTC3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba66604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("kXsK");
function injectStyle (ssrContext) {
  __webpack_require__("AL6B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ba66604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba66604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dioU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap"},[_c('div',{staticClass:"view-content"},[_c('section',{staticClass:"standard-hero bg-regular",attrs:{"id":"hero"}},[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"tagline",class:_vm.is.mac() ? 'apple' : 'no-apple'},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"intro-img"},[_c('img',{staticClass:"app-store",attrs:{"srcset":__webpack_require__("ZWju")+ ' 2x',"src":__webpack_require__("WNUp"),"alt":""}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-text"},[_c('h1',{staticClass:"text-left"},[_vm._v("RememBear is no longer available...")]),_vm._v(" "),_c('p',{staticClass:"text-left"},[_vm._v("There is no easy way to say this. Support for RememBear has ended and is no longer available to download. You can"),_c('a',{attrs:{"href":"https://www.remembear.com/blog/saying-goodbye-to-remembear","target":"_blank"}},[_vm._v(" read more about our decision here.")])]),_vm._v(" "),_c('p',{staticClass:"text-left mtop-20"},[_vm._v("Thank you for all of the brilliant years and support.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f6gU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fDlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap bg-dark"},[_c('div',{staticClass:"view-content bg-regular"},[_c('section',{staticClass:"text-center"},[_c('div',{staticClass:"section-inner"},[_c('div',[_c('div',{staticClass:"img-wrap"},[_c('img',{staticClass:"share-gif",attrs:{"src":'/static/images/social-gifs/' + this.$route.name + '.gif',"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"copy"},[_c('h1',{staticClass:"h2"},[_vm._v("You've Discovered an Achievement Bear!")]),_vm._v(" "),_c('p',[_vm._v("Achievement Bears help people become more secure in the internet wilderness. You can find and collect your own in RememBear.")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-lg",attrs:{"to":{ name: 'try', query: {utm_source: 'achievement-share'} }}},[_vm._v("What is RememBear?")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fL3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js__ = __webpack_require__("MMt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'download',
  data: function data() {
    return {
      is: __WEBPACK_IMPORTED_MODULE_2_is_js___default.a,
      win64: navigator.userAgent.indexOf('WOW64') !== -1 || navigator.userAgent.indexOf('Win64') !== -1,
      animation: {},
      downloaded: false
    };
  },

  computed: {
    skipAutodownload: function skipAutodownload() {
      return this.ENV.name !== 'production' || __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('downloaded') || __WEBPACK_IMPORTED_MODULE_2_is_js___default.a.mobile();
    }
  },
  beforeMount: function beforeMount() {
    this.$emit('modifyLayout', {
      bgColor: 'bg-blue'
    });
  },
  methods: {
    play: function play(delay) {
      var _this = this;

      if (delay) {
        setTimeout(function () {
          _this.animation.play();
        }, delay);
      } else {
        this.animation.play();
      }
    },
    autoDownload: function autoDownload() {
      if (this.skipAutodownload) {
        return;
      }
      if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.mac()) {
        document.getElementById('download-frame').src = this.external.downloadLinks.mac;
      } else if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.windows()) {
        var frameSrc = this.external.downloadLinks.windows32;
        if (this.win64) {
          frameSrc = this.external.downloadLinks.windows64;
        }
        document.getElementById('download-frame').src = frameSrc;
      }
      var time = new Date();
      time.setTime(time.getTime() + 1 * 3600 * 1000);
      __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('downloaded', true, { expires: time });
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var _this2 = this;

      this.animation = __WEBPACK_IMPORTED_MODULE_0_bodymovin_build_player_bodymovin_light_min_js___default.a.loadAnimation({
        container: this.$refs.heroAnimate,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '/static/animationData/download.json'
      });
      this.play(1000);
      setTimeout(function () {
        if (!_this2.downloaded) _this2.autoDownload();
      }, 2000);
    });
  }
});

/***/ }),

/***/ "g/k9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-android@2x.cd56a18.png";

/***/ }),

/***/ "gPr7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"child",class:_vm.layout + ' ' + _vm.classes},[_c('div',{staticClass:"img-txt-inner"},[_c('img',{style:({'max-width': _vm.imgWidth + 'px'}),attrs:{"src":_vm.getSrc(_vm.img),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"txt",style:({'max-width': (parseInt(_vm.imgWidth) * 2.5) + 'px'})},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.txt)?_c('p',[_vm._v(_vm._s(_vm.txt))]):_vm._e(),_vm._v(" "),(_vm.rawHtml)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.rawHtml)}}):_vm._e(),_vm._v(" "),(_vm.ctaCopy)?_c('a',{attrs:{"href":_vm.ctaLink}},[_vm._v(_vm._s(_vm.ctaCopy))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h0wn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/app-of-the-day-white.89fd13a.svg";

/***/ }),

/***/ "h6Y3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "i9Gr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    applyMeta: function applyMeta(metaTags, canonical) {
      if (!metaTags) {
        return;
      }

      try {
        if (location.pathname.indexOf('/share') > -1) {
          document.head.querySelector('[property="og:url"]').content = "https://www.remembear.com" + metaTags.image;
          document.head.querySelector('[property="og:type"]').content = 'image/gif';
        } else {
          document.head.querySelector('[property="og:url"]').content = "https://www.remembear.com" + location.pathname;
          document.head.querySelector('[itemprop="description"]').content = metaTags.description;
          document.head.querySelector('[property="og:type"]').content = 'article';
        }
        document.head.querySelector('[rel="canonical"]').setAttribute('href', "https://www.remembear.com" + (canonical || location.pathname));
        document.head.querySelector('[name="description"]').content = metaTags.description;
        document.head.querySelector('[itemprop="name"]').content = metaTags.title;
        document.head.querySelector('[itemprop="image"]').content = "https://www.remembear.com" + metaTags.image;

        if (metaTags.card !== 'app') {
          var tags = ['twitter:app:name:iphone', 'twitter:app:id:iphone', 'twitter:app:name:ipad', 'twitter:app:id:ipad', 'twitter:app:name:googleplay', 'twitter:app:id:googleplay'];
          if (metaTags.card === 'none') {
            tags = tags.concat(['twitter:card', 'twitter:site', 'twitter:title', 'twitter:image', 'twitter:description', 'twitter:creator']);
          }
          tags.forEach(function (key) {
            var elem = document.head.querySelector('[name="' + key + '"]');
            elem.parentNode.removeChild(elem);
          });
        }
      } catch (e) {}
      // no tag found.


      // Adding facebook and twitter meta tags
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(metaTags).forEach(function (key) {
        var tag = metaTags[key];
        if (key === 'image') {
          tag = "https://www.remembear.com" + tag;
        }

        var twitterTag = '';
        if (key.indexOf('tw_') > -1 && tag) {
          twitterTag = document.head.querySelector('[name="twitter:' + key.substring(3) + '"]');
        } else {
          twitterTag = document.head.querySelector('[name="twitter:' + key + '"]');
        }
        if (twitterTag) {
          twitterTag.content = tag;
        }

        var fbTag = document.head.querySelector('[property="og:' + key + '"]');
        if (fbTag) {
          fbTag.content = tag;
        }
      });
    }
  }
});

/***/ }),

/***/ "jSpy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDI2IDIyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNnYyMkgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiM0MzRENUIiIGQ9Ik0yNS4zMzYgMTkuMjIzSDE5LjcxbC0yLjY5LTUuOTk4YzIuOTk1LTEuMiA4LjQzNS0zLjgxOSA4LjQzNS03Ljg5QzI1LjQ1NS42IDIwLjQ0MyAwIDE3LjM1NyAwSDIuMzIyTDAgMy44ODNoMTUuMjE3YzEuNzczIDAgMy43Ni41MDUgMy43NiAyLjc0NiAwIDEuNzM2LTEuMjIzIDMuMDYxLTIuOTY1IDMuOTc2LS42MS4zNDgtNC4yMTcgMS43MzctNC45OCAxLjg5NGwyLjkzMyA2LjcyNGMuNjcyIDEuNTc3IDEuMDcgMi40NjEgMi44MTEgMi40NjFoNS40NjdjLjkyOCAwIDEuNzg3LS4zMzIgMi4zNzQtLjkyNC41ODYtLjU5Mi43MDItMS4wOTYuNzE5LTEuNTM3ek03LjczIDUuODdMMi4zMjIgMjEuNjg0aDUuMzc5TDEzLjE0IDUuODcxSDcuNzMxeiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "jUxj":
/***/ (function(module, exports) {

module.exports = {"countries":["Afghanistan","Åland Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo","Congo, The Democratic Republic of The","Cook Islands","Costa Rica","Cote D'ivoire","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands (Malvinas)","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-bissau","Guyana","Haiti","Heard Island and Mcdonald Islands","Holy See (Vatican City State)","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran, Islamic Republic of","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea, Democratic People's Republic of","Korea, Republic of","Kuwait","Kyrgyzstan","Lao People's Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libyan Arab Jamahiriya","Liechtenstein","Lithuania","Luxembourg","Macao","Macedonia, The Former Yugoslav Republic of","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia, Federated States of","Moldova, Republic of","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestinian Territory, Occupied","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russian Federation","Rwanda","Saint Helena","Saint Kitts and Nevis","Saint Lucia","Saint Pierre and Miquelon","Saint Vincent and The Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and The South Sandwich Islands","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Swaziland","Sweden","Switzerland","Syrian Arab Republic","Taiwan","Tajikistan","Tanzania, United Republic of","Thailand","Timor-leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands","Uruguay","Uzbekistan","Vanuatu","Venezuela","Vietnam","Virgin Islands, British","Virgin Islands, U.S.","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"],"states":["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming","District of Columbia","Puerto Rico","Guam","American Samoa","U.S. Virgin Islands","Northern Mariana Islands"],"provinces":["Alberta","British Columbia","Manitoba","New Brunswick","Newfoundland and Labrador","Northwest Territories","Nova Scotia","Nunavut","Ontario","Prince Edward Island","Quebec","Saskatchewan","Yukon"]}

/***/ }),

/***/ "k/hj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bear-sitting-on-a-laptop.f87bc92.png";

/***/ }),

/***/ "kXsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-dark",attrs:{"id":"footer"}},[_c('div',{staticClass:"view-wrap"},[_c('section',{staticClass:"show-minimal minimal text-center"},[_c('p',{staticClass:"fine-print-lg"},[_vm._v("©"+_vm._s(_vm.year)+" TunnelBear LLC.")])]),_vm._v(" "),_c('section',{staticClass:"not-minimal smaller"},[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"footer-column"},[_c('h6',[_vm._v("RememBear")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":_vm.external.help}},[_vm._v("Help")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.ENV.blogURL}},[_vm._v("Blog")])])])]),_vm._v(" "),_c('div',{staticClass:"footer-column"},[_c('h6',[_vm._v("Company")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'privacy-policy'}}},[_vm._v("Privacy Notice")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'terms-of-service'}}},[_vm._v("Terms of Service")])],1)])]),_vm._v(" "),_c('div',{staticClass:"footer-column"},[_c('h6',[_vm._v("Follow Us")]),_vm._v(" "),_c('ul',{staticClass:"horizontal"},[_c('li',[_c('a',{staticClass:"icon-parent",attrs:{"href":_vm.external.facebookUrl}},[_vm._m(0)])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"icon-parent",attrs:{"href":_vm.external.instagramUrl}},[_vm._m(1)])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"text-center",attrs:{"id":"signature"}},[_c('img',{attrs:{"src":__webpack_require__("aMNx"),"alt":"RememBear"}}),_vm._v(" "),_c('p',[_vm._v("©"+_vm._s(_vm.year)+" TunnelBear LLC.")]),_vm._v(" "),_c('p',[_vm._v("Grizzly regards from Toronto, Canada")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon icon-facebook"},[_c('span',[_vm._v("Facebook")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon icon-instagram"},[_c('span',[_vm._v("Instagram")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"id":"essentials"}},[_c('h6',[_vm._v("Get the Bear Essentials")]),_vm._v(" "),_c('div',{staticClass:"apps"},[_c('a',{staticClass:"dark",attrs:{"href":"https://www.tunnelbear.com","aria-label":"TunnelBear website"}},[_c('div',{staticClass:"app"},[_c('img',{attrs:{"src":__webpack_require__("uZpC"),"alt":"TunnelBear"}}),_vm._v(" "),_c('span',[_vm._v("TunnelBear")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "loLo":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./screenshots-mac.png": "rvvE",
	"./screenshots-mac@2x.png": "KJxS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "loLo";

/***/ }),

/***/ "mvRF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/browsers.92887d3.png";

/***/ }),

/***/ "nYrJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nve7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "o34E":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/independently-audited@2x.b4e2ae1.png";

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_pricing_json__ = __webpack_require__("crmo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_pricing_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__data_pricing_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_services_js__ = __webpack_require__("TZir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_location_service_js__ = __webpack_require__("DCoa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_is_js__);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    isLoggedIn: !!__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('RB_SESSION'),
    locationService: new __WEBPACK_IMPORTED_MODULE_6__services_location_service_js__["a" /* LocationService */](),
    toRoute: {},
    userData: {},
    pricingData: __WEBPACK_IMPORTED_MODULE_4__data_pricing_json___default.a,
    pricingReceived: false,
    paymentToken: '',
    submitting: false,
    modalOpen: false
  },
  mutations: {
    setUserData: function setUserData(state, data) {
      state.userData = data;
    },
    setPricingData: function setPricingData(state, data) {
      state.pricingReceived = true;
      state.pricingData = data;
    },
    saveNextRoute: function saveNextRoute(state, data) {
      state.toRoute = data;
    },
    clearUserData: function clearUserData(state) {
      state.userData = {};
    },
    paymentToken: function paymentToken(state, token) {
      state.paymentToken = token;
    },
    submitting: function submitting(state, _submitting) {
      state.submitting = _submitting;
    },
    modalOpen: function modalOpen(state, status) {
      state.modalOpen = status;
    }
  },
  actions: {
    prepareUserData: function prepareUserData(_ref, forceRefresh) {
      var _this = this;

      var commit = _ref.commit,
          state = _ref.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!__WEBPACK_IMPORTED_MODULE_5__services_services_js__["a" /* default */].objIsEmpty(state.userData) && !forceRefresh) {
          resolve();
        } else {
          _this.$http.get(_this.ENV.apiBaseUrl + '/web/account/details').then(function (response) {
            commit('setUserData', response.data);
            resolve();
          }).catch(function (error) {
            if (error.response) {
              if ([401, 429].indexOf(error.response.status) > -1) {
                if (__WEBPACK_IMPORTED_MODULE_7_is_js___default.a.ios()) __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.remove('RB_SESSION', { domain: '.remembear.com' });
                window.location.href = _this.ENV.apiBaseUrl + '/web/account/logout';
              }
            }
            reject(error);
          });
        }
      });
    },
    preparePricingDetails: function preparePricingDetails(_ref2, coupon) {
      var _this2 = this;

      var commit = _ref2.commit,
          state = _ref2.state;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (state.pricingReceived) {
          resolve();
        } else {
          _this2.$http.get(_this2.ENV.paymentBaseUrl + '/pricing', {
            params: {
              app: 'REMEMBEAR'
            }
          }).then(function (response) {
            commit('setPricingData', response.data);
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    },
    getPaymentToken: function getPaymentToken(_ref3) {
      var _this3 = this;

      var commit = _ref3.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.$http.get(_this3.ENV.apiBaseUrl + '/web/account/paymentToken').then(function (response) {
          commit('paymentToken', response.data);
          resolve();
        }).catch(function (error) {
          reject();
        });
      });
    },
    submitting: function submitting(_ref4, _submitting2) {
      var commit = _ref4.commit;

      commit('submitting', _submitting2);
    },
    modalOpen: function modalOpen(_ref5, status) {
      var commit = _ref5.commit;

      commit('modalOpen', status);
    }
  },
  getters: {
    nextRoute: function nextRoute(state) {
      return state.toRoute;
    },
    userData: function userData(state) {
      return state.userData;
    },
    pricingData: function pricingData(state) {
      return state.pricingData;
    },
    isLoggedIn: function isLoggedIn(state) {
      return state.isLoggedIn;
    },
    paymentToken: function paymentToken(state) {
      return state.paymentToken;
    },
    submitting: function submitting(state) {
      return state.submitting;
    },
    modalOpen: function modalOpen(state) {
      return state.modalOpen;
    }
  }
}));

/***/ }),

/***/ "pd/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_vue__ = __webpack_require__("fL3/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdbbb3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_vue__ = __webpack_require__("vAx3");
function injectStyle (ssrContext) {
  __webpack_require__("VGxG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bdbbb3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_download_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdbbb3f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_download_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qZDG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-android.c6286fd.png";

/***/ }),

/***/ "qgjm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/friendly-design.17226bc.svg";

/***/ }),

/***/ "qnTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.layout.hideNav)?_c('nav-bar',{staticClass:"do-not-print"}):_vm._e(),_vm._v(" "),_c('router-view',{on:{"modifyLayout":_vm.modifyLayout}}),_vm._v(" "),(!_vm.layout.hideFooter)?_c('site-footer',{staticClass:"do-not-print",attrs:{"minimal":_vm.layout.minimalFooter}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rqTX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/faster-login.7407938.svg";

/***/ }),

/***/ "rvvE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-mac.57106a5.png";

/***/ }),

/***/ "sBY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sQOs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_services_js__ = __webpack_require__("TZir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_is_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'site-navigation',
  data: function data() {
    return {
      is: __WEBPACK_IMPORTED_MODULE_1_is_js___default.a,
      menuVisible: false,
      scrolled: false
    };
  },

  created: function created() {
    window.addEventListener('scroll', this.calculateNavState);
  },
  methods: {
    calculateNavState: function calculateNavState() {
      if (__WEBPACK_IMPORTED_MODULE_0__services_services_js__["a" /* default */].windowScrollTop() > 50) {
        if (this.scrolled) return;
        this.scrolled = true;
      } else {
        if (!this.scrolled) return;
        this.scrolled = false;
      }
    },
    logout: function logout() {
      window.location.href = this.ENV.apiBaseUrl + '/web/account/logout';
    }
  },
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.state.isLoggedIn;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.menuVisible = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.calculateNavState);
  }
});

/***/ }),

/***/ "sRL0":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./access-from-anywhere.svg": "E+qO",
	"./easily-access-credit-cards.svg": "SFnC",
	"./faster-login.svg": "rqTX",
	"./friendly-design.svg": "qgjm",
	"./independently-audited@2x.png": "o34E",
	"./never-forget-password.svg": "3+Gb",
	"./save-time.svg": "57Hz",
	"./secure-notes.svg": "se6s",
	"./secured-end-to-end.svg": "Rqlq",
	"./serious-security.svg": "JQLz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sRL0";

/***/ }),

/***/ "se6s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/secure-notes.1ca581e.svg";

/***/ }),

/***/ "tAFp":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./screenshots-ios.png": "za/q",
	"./screenshots-ios@2x.png": "d5hg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tAFp";

/***/ }),

/***/ "tm+N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap bg-dark"},[_c('div',{staticClass:"view-content bg-regular"},[_c('section',{staticClass:"element xs centered text-center"},[_c('img',{staticClass:"bear",attrs:{"src":__webpack_require__("Tacz"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("Your Bear has been upgraded to RememBear Premium")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg",attrs:{"href":"remembear://sync"}},[_vm._v("Open the App")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uZpC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiIgdmlld0JveD0iMCAwIDI1NiAyNTYiPgogICAgPGRlZnM+CiAgICAgICAgPHBhdGggaWQ9ImEiIGQ9Ik0yMzkuMTMgOTUuMzA3YzQuOTI1IDEzLjA0MSA3LjYyIDI3LjE3OCA3LjYyIDQxLjk0M0MyNDYuNzUgMjAyLjgzNCAxOTMuNTg0IDI1NiAxMjggMjU2UzkuMjUgMjAyLjgzNCA5LjI1IDEzNy4yNWMwLTE0Ljc2NSAyLjY5NS0yOC45MDEgNy42Mi00MS45NDMtLjA4LTEuODQyLS4xMi0zLjY5NC0uMTItNS41NTdDMTYuNzUgMjQuMTY2IDY2LjU1OS0yOSAxMjgtMjljNjEuNDQyIDAgMTExLjI1IDUzLjE2NiAxMTEuMjUgMTE4Ljc1IDAgMS44NjMtLjA0IDMuNzE1LS4xMiA1LjU1N3oiLz4KICAgICAgICA8cGF0aCBpZD0iYyIgZD0iTTIzOS4xIDYyLjExMlYuMDYySC4yMmwtLjEyMyA2Mi4wNWgyMzkuMDAxeiIvPgogICAgICAgIDxwYXRoIGlkPSJlIiBkPSJNLjQ3MS4wNjdMLjE5OCAxMzcuMmguMDAzYzAgLjA4My0uMDAzLjE2Ni0uMDAzLjI1LjExNSAyOC4wNjYgNTMuNjMzIDUwLjgzIDExOS41MzYgNTAuODk5IDguMzk3LjAwOSAxNi41OTQtLjM1IDI0LjUwNS0xLjA0NFYuMDY3SC40NzF6Ii8+CiAgICAgICAgPHBhdGggaWQ9ImciIGQ9Ik0yNTYuMTI0IDYzLjQyM3YtMzEuMzRoLS4wMDJsLjAwMi0uMDY2QzI1Ni4yMzIgMTQuNDQxIDE5OC45NS4xNDcgMTI4LjE2MS4wOTVoLS4zNzVDNTcuMTkzLjA5NC4wODQgMTQuMjgzLjE0MyAzMS44MThsLjAwMy4wOUguMTQydjMxLjUxNWgyNTUuOTgxeiIvPgogICAgICAgIDxwYXRoIGlkPSJpIiBkPSJNMTg1LjE1NyAwYzYxLjI2Mi4wNTUgNTMuODU2IDEwNi41NzEgNTMuNzkgMTE5Ljg0My0uMDY0IDEzLjI1NC00OS42OTYgMjMuOTU1LTExMC44NDIgMjMuOTA0LTYxLjE0OC0uMDM1LTExMC43NTMtMTAuODItMTEwLjc5MS0yNC4wODVDMTcuMjggMTA2LjM5OCA3LjE2Ny0uMDQyIDY4LjQyMiAwaDExNi43MzV6Ii8+CiAgICAgICAgPHBhdGggaWQ9ImsiIGQ9Ik05Ni4zNTUuMzI4Yy0zMS43NjkgMi42ODMtNjIuMjk3IDEyLjEzNS03NS4yMiA1MS44NTctNi4yOTYgMTcuMDkyLTEwLjQ1MiAzNC42Ny0xMy4wNSA1MS4wNjUtMS4wNTEgNi42NDItNC4xNDIgMTQuOTMtOC4wMjcgMjMuNDc0IDIwLjE5IDUuOTE3IDUyLjU2NSA5Ljc2NCA4OS4wNDcgOS43ODYgMzYuMDI1LjAzIDY4LjA1NS0zLjY3MiA4OC4zMDQtOS40My0yLjAxOS0xMC40NzItMi40My0yMC4zMDItMi44MzMtMzMuMjY2IDMuNzY3LTM5Ljk5NS03LjM3NS04My4yODYtMzcuMjgxLTg3LjUzNy0xMC40MjUtMS40ODItMjQuMjM1LTYuMTEtMzYuOTgtNi4xMS0xLjMzNCAwLTIuNjU1LjA1LTMuOTYuMTYxeiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHBhdGggZmlsbD0iI0NDRTA4QiIgZD0iTTEyOCAxOC41YzY1LjU4NCAwIDExOC43NSA1My4xNjYgMTE4Ljc1IDExOC43NVMxOTMuNTg0IDI1NiAxMjggMjU2IDkuMjUgMjAyLjgzNCA5LjI1IDEzNy4yNSA2Mi40MTYgMTguNSAxMjggMTguNSIgbWFzaz0idXJsKCNiKSIvPgogICAgICAgIDxnIG1hc2s9InVybCgjYikiPgogICAgICAgICAgICA8cGF0aCBmaWxsPSIjRUNBQjI1IiBkPSJNMjQ5LjU5NSAyODQuNjg3aC4wMDRWMTQ3LjU1SDEwLjcyMmwtLjI3NCAxMzcuMTM4aC4wMDNjMCAuMDg0LS4wMDMuMTY3LS4wMDMuMjUuMTE1IDI4LjA2NyA1My42MzMgNTAuODMgMTE5LjUzNiA1MC45IDY1LjkwMy4wNyAxMTkuNDU2LTIyLjU3OCAxMTkuNjE1LTUwLjY0NS4wMDEtLjE2OC0uMDAxLS4zMzctLjAwNC0uNTA1Ii8+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjUgMTQ3LjQ4OCkiPgogICAgICAgICAgICAgICAgPG1hc2sgaWQ9ImQiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2MiLz4KICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNDRjk0MjciIGQ9Ik0xMTUuODI1LTI3LjIxYzg5LjM2NCAxLjk5OCAxNjEuMjQ0IDIzLjU4IDE2MC41NDYgNDguMjA1LS42OTcgMjQuNjI1LTczLjcwNiA0Mi45NjctMTYzLjA3MSA0MC45NjgtODkuMzY1LTEuOTk4LTE2MS4yNDMtMjMuNTgtMTYwLjU0Ni00OC4yMDUuNjk3LTI0LjYyNSA3My43MDYtNDIuOTY3IDE2My4wNy00MC45NjkiIG1hc2s9InVybCgjZCkiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC4yNSAxNDcuNDg4KSI+CiAgICAgICAgICAgICAgICA8bWFzayBpZD0iZiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjZSIvPgogICAgICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0NGOTQyNyIgZD0iTTI2LjIwNSAzMy4wNzRzLTEuMjEgNDcuNzQgMzkuNTIxIDgwLjAxNmM2MS4xMjYgNDguNDM4IDYzLjUxMyAxNTkuNDEgNjMuNTEzIDE1OS40MUwtODYgMTMyLjI1Ny00MS42OTEuMDY3bDY3Ljg5NiAzMy4wMDd6IiBtYXNrPSJ1cmwoI2YpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgbWFzaz0idXJsKCNiKSI+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMyMzFGMjAiIGQ9Ik0xMjguMTYgOTUuNzA5YzYxLjI2My4wNTUgMTEwLjg1MyAxMC44NjIgMTEwLjc4NiAyNC4xMzQtLjA2MyAxMy4yNTQtNDkuNjk1IDIzLjk1NS0xMTAuODQxIDIzLjkwNC02MS4xNDgtLjAzNS0xMTAuNzUzLTEwLjgyLTExMC43OTEtMjQuMDg1LS4wMzQtMTMuMjY0IDQ5LjU5Mi0yMy45OTUgMTEwLjg0Ny0yMy45NTMiLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0FBNzEyQSIgZD0iTTE3Mi42NTkgMjUuODk5czEwLjg5Ni0uNCAyNS4zNS0uNTc1YzEzLjA2Ni0uMTU4IDE2Ljg1IDkuODEgMTYuMDk4IDE2LjEtMS44MTUgMTUuMTc1LTcuMDIgMTcuOTk1LTIxLjA5NyAzMi4wOTktOC41MjUtMi4wOS0xNi4yMzgtMTQuMTI3LTE5LjcwNC0yNy41NTctMi4zMzQtOS4wNTQtLjY0Ny0yMC4wNjctLjY0Ny0yMC4wNjciLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0IyNzYyQyIgZD0iTTEwNy4wNzEgMjUuMzk0Uzg4LjIxIDE4LjM2MyA3MC43ODMgMTMuODVjLTE1LjgxNS00LjA5Ni0yNC45MzEgOS40OC0yNS44MzYgMTYuOTEzLTIuMzkyIDE5LjY0NCAxMS4zNTQgMzAuMTgyIDI1LjU0NCAzNy4zNyAxMC45MS4wODYgMTQuOS03LjcxIDIyLjg3Ni0yMi4wNDEgNS4zNjYtOS42NSAxMy43MDQtMjAuNjk3IDEzLjcwNC0yMC42OTciLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0iI0U5QTgyNCIgZD0iTTI1Ni4xMjQgMTIwLjc1NWMuMTA4LTE3LjU3Ny01Ny4xNzQtMzEuODctMTI3Ljk2My0zMS45MjJDNTcuNDAxIDg4Ljc4My4wODQgMTAyLjk5LjE0MyAxMjAuNTU1bC4wMDMuMDkxSC4xNDN2NDEuNzAyaC4wMDNjLjI1IDE2LjU5NyA1Ny41NzUgMzAuMDY3IDEyNy45NDggMzAuMTIgNzAuMzk4LjAzNiAxMjcuNzQtMTMuMzM2IDEyOC4wMjgtMjkuOTM1aC4wMDJWMTIwLjgyaC0uMDAybC4wMDItLjA2NiIvPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDg4LjczNykiPgogICAgICAgICAgICAgICAgPG1hc2sgaWQ9ImgiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2ciLz4KICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkQwNEIiIGQ9Ik0xMjguMTUyLS4xNjNjNzAuODMzLjA1MiAxMjguMTUgMTQuMzU1IDEyOC4wNDMgMzEuOTQyLS4xMzIgMTcuNTQtNTcuNDggMzEuNjk3LTEyOC4xMSAzMS42NDRDNTcuNDU4IDYzLjM3My4xMzcgNDkuMTMzLjA1NCAzMS41NzktLjAwNiAxNC4wMDQgNTcuMzQ3LS4yMTMgMTI4LjE1MS0uMTYzIiBtYXNrPSJ1cmwoI2gpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPG1hc2sgaWQ9ImoiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjaSIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxwYXRoIGZpbGw9IiM1QzQwMUIiIGQ9Ik0xMjguMTYgOTUuNzA5YzYxLjI2My4wNTUgMTEwLjg1MyAxMC44NjIgMTEwLjc4NiAyNC4xMzQtLjA2MyAxMy4yNTQtNDkuNjk1IDIzLjk1NS0xMTAuODQxIDIzLjkwNC02MS4xNDgtLjAzNS0xMTAuNzUzLTEwLjgyLTExMC43OTEtMjQuMDg1LS4wMzQtMTMuMjY0IDQ5LjU5Mi0yMy45OTUgMTEwLjg0Ny0yMy45NTMiIG1hc2s9InVybCgjaikiLz4KICAgICAgICAgICAgPGcgZmlsbD0iI0Q0OEMzNiIgbWFzaz0idXJsKCNqKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjE3LjE5MiAxMzguMDUxYy0yLjcwNS0xMS45MzQtMy4xNjUtMjIuNTA4LTMuNjE2LTM3IDMuNzY3LTM5Ljk5NS03LjM3NS04My4yODUtMzcuMjgxLTg3LjUzNy0xMS41MTYtMS42MzctMjcuMTYxLTcuMTEyLTQwLjk0LTUuOTQ5LTMxLjc2OSAyLjY4NC02Mi4yOTcgMTIuMTM1LTc1LjIyIDUxLjg1OC02LjI5NSAxNy4wOTItMTAuNDUyIDM0LjY3LTEzLjA1IDUxLjA2NS0zLjU1MyAyMi40NTQtMzAuNDEgNjMuNzIxLTMyLjUyOCA3MC4wNjYtMS42NDMgNC45MjIgMjEzLjgyMyAxNC4wOTMgMjEzLjQ5NiAxMC42NTQtLjc3NS04LjE3LTcuOTkzLTQwLjUwNC0xMC44NjEtNTMuMTU3Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPGcgbWFzaz0idXJsKCNqKSI+CiAgICAgICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzOSA3LjIzNykiPgogICAgICAgICAgICAgICAgICAgIDxtYXNrIGlkPSJsIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjayIvPgogICAgICAgICAgICAgICAgICAgIDwvbWFzaz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjQzM4MjJFIiBkPSJNMjUyLjYwNyAxMzYuMDE0cy04My4yNzMgNDMuNDYtMTQxLjc0MyAyMi44NzRjLTQ3LjYtMTYuNzYtODIuMTk2LTU4LjkyMi03OC4yODgtOTYuODE3QzM1LjggMzAuNzg4IDQ4LjY2IDEyLjI5MiA3My43NDggMS43MDcgOTguMzE2LTguNjU4IDEyLjQwMy05LjkyMSAxMi40MDMtOS45MjFsLTMwLjA2IDMyLjM1Ny0yMS4xMDYgMTYwLjgwMSAxOTMuNSA5OS4zOTUgOTcuODctMTQ2LjYxOHoiIG1hc2s9InVybCgjbCkiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8ZyBtYXNrPSJ1cmwoI2opIj4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNDMDdGMzAiIGQ9Ik0xODkuNjYgNzEuMzg0Yy0uNjUzIDguODEgNy44NCAzMy40ODMgMy4xOTQgNDIuMTMtNC4yNDQgNy44OTYtMjAuNzQ5IDguOTY3LTI4LjMwMy44NzQtNy41NzItOC4xMTMtNi44NjktMjkuMDE2LTcuNzg2LTQxLjQzNy0xLjEyNy0xNS4yNSAzMy44MDQtMTMuODA3IDMyLjg5Ni0xLjU2NyIvPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZEQ0I4MyIgZD0iTTE4OC43NjkgMS4wMTRjLTguODc2LTEuODQ4LTE1LjA1MSAyLjA4NC0xOS4yNTYgNS4zMDItNi43MTcgNS4xNC0xMS4yMDcgOC45ODktMTIuNTYxIDEzLjAxMy0xLjI2IDMuNzQ3LTMuODE2IDE4LjY4Ny00LjE5MiAyNi4xMjgtLjUyNCAxMC4zNDIgMS44ODQgMTguMTc3IDQuMzQ5IDMwLjQ3NCAxLjUyNCA3LjYwNCAyLjc2IDI0Ljk3NyAxMS4yNzQgMzAuODkgOC40OTUgNS44OTkgMjQuNzggMy43NjcgMjguMTg3LTIuOTk0IDMuNzMtNy40MDQtMy42NjMtMjcuNTMzLTQuMDc2LTMzLjMyNy0uNTczLTguMDUgMTAuNDktMTEuNzU0IDE0LjY2Mi0zMC4zNDQgMS4xOTctNS4zMzMgMS43OS0xMC40MTQgMS43MDctMTUuMTI4LS4xNDItNy45NjktMi40Ni0xNC41ODgtNS40My0xNy41MzEtNC4zNTUtNC4zMTUtOS4xNS01LjMzNC0xNC42NjQtNi40ODMiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMyMzFGMjAiIGQ9Ik0xOTIuOTE2IDE4LjE3OGMtMy4wMjYtLjcxMy03LjcxLTIuOTU5LTEwLjY4Ny03LjQyNy0yLjQxNy0zLjYzLTcuNjU1LTEwLjUzNSAyLjU0LTEwLjQxMyA3LjEzNS4wOTQgMTAuNzE1Ljk4MSAxNS44NDcgMy43NTIgMy42OTcgMS45OTEgNC40NDMgMy44MzQgMy4zNTcgNi44Ni0xLjk5IDUuNTA0LTcuNzUyIDguMDEtMTEuMDU3IDcuMjI4TTE5NC4wMDYgOTcuOTM2Yy0uOTk0IDMuOTY1LTEwLjgxOSA2LjA0LTE1LjU1MiA1LjA2Ni03LjE1OS0xLjQ3NS0xNC44MzQtMi45MTYtMTYuNzkzLTIwLjE2NS0yLjAyNi0xNy44NDgtMi4yMDgtMjUuOTcgMy44MTItMzkuMDQxIDMuNTg0LTcuODIzIDUuMjg0LTE3LjI0NSAyMy42Mi0xMy43OTMgMjcuNDIxIDUuMTU0IDcuNTI3IDIzLjk3OCAyLjU5NiAzMS42NzctMy4yMjMgNS4wNDQtMy42OTggNi43NjYtMi41OTkgMTEuMzIxIDEuMTUzIDQuODAyIDYuNTI0IDE4LjUxOCA0LjkxNiAyNC45MzUiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRUVEREEiIGQ9Ik0xNzEuMTA5IDM3LjAzMWMtLjUxNS44MzEtLjA0MyA5LjkwOCAxLjEyOCAxMi43OTIgMi4wNyA1LjAzIDUuMjAxLTkuNzYgNy4zNzYtMTAuMzM4IDIuMTY5LS41NzEgMTMuODYgMS4zNjEgMTYuMjE2IDIuODgxIDIuMjk4IDEuNTkzLS4yMDIgMTEuMzQgMi4xMjUgMTEuODE2IDIuMzI2LjQ3NSA1LjAzNy0xMC41ODUgNC4xMDYtMTMuODE5LTEuMDM1LTMuNi01LjM0OS01LjcwMi0xMS40MDUtNy4wMDQtNS45MzYtMS4yNzctMTUuNjcyLTIuNTg1LTE5LjU0NiAzLjY3MiIvPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzYzMDcxNiIgZD0iTTE2OS4xIDgzLjc3OGMyLjE1MiA4LjU2MyA2Ljc4MyAxMS45MTYgMTEuMzkgMTAuNyA0LjYxMi0xLjIxNyA3Ljc4Ni05LjA4IDUuNjM0LTE3LjY0My0yLjE1Mi04LjU2NC05LjI1My0xMS4wOTMtMTcuNzA1LTkuNzM0LTIuNDM2LjM5Mi01LjE0MiAzLjE0LTUuMTcgNS45NDctLjAzNiAzLjY5OSA0LjI5OCA0LjU0OSA1Ljg1MSAxMC43MyIvPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0ZFRUREQSIgZD0iTTE5My42OTUgODAuODM3YzEuMjY3LjcyMS4zNDcgMTIuMDY0LTEuOTYgMTMuODI2LTIuMzEyIDEuNzUzLTQuNjg2IDIuNTg2LTExLjI0NSAyLjE4My02Ljc0OC0uNDI1LTkuNjMtMi4wMjEtMTEuNTE2LTMuNzktMS40NzMtMS40LTEuMDc5LTE0LjI2MSAxLjEwOC0xNC40NTUgMi4xODEtLjE5NCA0LjkgMTAuNTgzIDQuOSAxMC41ODNzMTAuMTMgMS4yNzUgMTMuODA4LjE4M2MxLjc4LTMuMjQgMy4zOTItOS4zOTYgNC45MDUtOC41MyIvPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0JEN0UyRiIgZD0iTTE0NS45NDIgMjUuMTljLTQuMzkzLjE1NS05LjM4Ny42MzYtOS43NDMtLjAwMy0xLjIwMy0yLjE1NSAyLjg3Mi03LjI3MSA3LjAyNS04LjM0NCA1LjQ4MS0xLjQxNyAxMC41NTggMy40MDYgMTAuMTgzIDYuMTQzLS4yNjEgMS44OTgtMy43NDIgMi4wNzQtNy40NjUgMi4yMDQiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMyMzFGMjAiIGQ9Ik0xMzkuOTQzIDIzLjcyYy0uNDU0IDMuMzAyIDEuOTUgNS4zOTUgNi4zNSA1LjIzNyAzLjc0Ni0uMTM5IDUuNDctMS4zIDUuNTk3LTQuNjQ0LjA4OS0yLjM0Ny0yLjE2LTUuMTE2LTYuMDM5LTUuMzM3LTMuNTMzLS4yMDItNS41NzYgMi4zMTYtNS45MDggNC43NDMiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRUZFRkUiIGQ9Ik0xNDcuMjgyIDIwLjUzNmMuNjgzLjE1NyAxLjEyMS45MDEuOTggMS42NjMtLjE0Mi43NjItLjgxIDEuMjUzLTEuNDkzIDEuMDk2LS42ODMtLjE1Ny0xLjEyMS0uOTAxLS45OC0xLjY2My4xNDItLjc2Mi44MS0xLjI1MyAxLjQ5My0xLjA5NiIgb3BhY2l0eT0iLjc2MiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "vAx3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-wrap"},[_c('div',{staticClass:"view-content bg-regular"},[_c('section',{staticClass:"standard-hero bg-blue",attrs:{"id":"hero"}},[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"tagline",class:_vm.is.mac() ? 'apple' : 'no-apple'},[(_vm.is.mobile() || _vm.skipAutodownload)?_c('div',[_c('h1',[_vm._v("Download RememBear")])]):_c('div',[_c('h1',[_vm._v("Thanks for downloading a Bear")]),_vm._v(" "),_c('p',[_vm._v("Your RememBear download should start automatically. If it doesn't, click your platform below")])])]),_vm._v(" "),_c('div',{staticClass:"animation-wrap"},[(_vm.is.ie())?_c('div',[_c('img',{staticClass:"animation retina-block",attrs:{"src":__webpack_require__("1YkC"),"alt":"Cartoon black bear sitting on laptop"}}),_vm._v(" "),_c('img',{staticClass:"animation low-res",attrs:{"src":__webpack_require__("k/hj"),"alt":"Cartoon black bear sitting on laptop"}})]):_c('div',{ref:"heroAnimate",staticClass:"animation"})])])]),_vm._v(" "),_c('section',{attrs:{"id":"downloads"}},[_c('div',{staticClass:"container"},[(!_vm.is.mobile())?_c('div',{staticClass:"section-inner-md text-center"},[_c('div',{staticClass:"apps"},[_c('div',{staticClass:"row download-row"},[_c('div',{staticClass:"download-col col-xs-12 col-sm-6 app"},[_c('a',{staticClass:"btn btn-lg dark-blue dl mac",attrs:{"id":"mac-dl","href":_vm.external.downloadLinks.mac,"download":""},on:{"click":function($event){_vm.downloaded = true}}},[_c('div',[_vm._v("Mac")])]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("64-bit macOS 10.12 and later")])]),_vm._v(" "),_c('div',{staticClass:"download-col col-xs-12 col-sm-6 app"},[_c('a',{staticClass:"btn btn-lg dark-blue dl ios",attrs:{"href":_vm.external.downloadLinks.ios}},[_c('div',[_vm._v("iOS")])]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("iPads and iPhones with iOS 11.2 and later")])])]),_vm._v(" "),_c('div',{staticClass:"row download-row"},[_c('div',{staticClass:"download-col col-xs-12 col-sm-6 app"},[_c('a',{staticClass:"btn btn-lg dark-blue dl windows",attrs:{"id":"pc-dl","href":_vm.win64 || _vm.is.mac() ? _vm.external.downloadLinks.windows64 : _vm.external.downloadLinks.windows32,"download":""},on:{"click":function($event){_vm.downloaded = true}}},[_c('div',[_vm._v("Windows")])]),_vm._v(" "),(_vm.win64 || _vm.is.mac())?_c('p',{staticClass:"fine-print"},[_vm._v("64‑bit Windows 10 and later. Looking for the "),_c('a',{attrs:{"href":_vm.external.downloadLinks.windows32,"download":""}},[_vm._v("32‑bit version")]),_vm._v("?")]):_c('p',{staticClass:"fine-print"},[_vm._v("32‑bit Windows 10 and later. Looking for the "),_c('a',{attrs:{"href":_vm.external.downloadLinks.windows64,"download":""}},[_vm._v("64‑bit version")]),_vm._v("?")])]),_vm._v(" "),_c('div',{staticClass:"download-col col-xs-12 col-sm-6 app"},[_c('a',{staticClass:"btn btn-lg dark-blue dl android",attrs:{"href":_vm.external.downloadLinks.android}},[_c('div',[_vm._v("Android")])]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("Android 5.0 and later")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"browsers"},[_c('div',{staticClass:"browser"},[_c('a',{staticClass:"btn btn-lg grey chrome-btn",attrs:{"href":_vm.external.downloadLinks.chrome}},[_c('div',[_vm._v("Chrome")])]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("Chrome Browser 22+ on Windows & macOS")])]),_vm._v(" "),_c('div',{staticClass:"browser"},[_c('a',{staticClass:"btn btn-lg grey firefox-btn",attrs:{"href":_vm.external.downloadLinks.firefox}},[_c('div',[_vm._v("Firefox")])]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("Firefox Browser 57+ on Windows & macOS")])])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"notices"},[_c('router-link',{staticClass:"fine-print",attrs:{"to":{ name: 'notices'}}},[_vm._v("Notice and Attribution")]),_vm._v(" "),_c('a',{staticClass:"fine-print",attrs:{"href":"https://help.remembear.com/hc/en-us/articles/360006847152"}},[_vm._v("Uninstall Remembear")])],1)])]):_vm._e()]),_vm._v(" "),(_vm.is.mobile())?_c('div',{staticClass:"mobile-cta"},[(_vm.is.android())?_c('div',[_c('a',{staticClass:"playstore",attrs:{"href":_vm.external.downloadLinks.android}},[_c('img',{attrs:{"src":__webpack_require__("h6Y3"),"alt":"Get it on Google Play"}})]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("Android 5.0 and later")])]):_c('div',[_c('a',{staticClass:"appstore",attrs:{"href":_vm.external.downloadLinks.ios}},[_c('img',{staticClass:"android",attrs:{"src":__webpack_require__("nve7"),"alt":"Download on the App Store"}})]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("iPads and iPhones with iOS 11.2 and later")])])]):_vm._e()]),_vm._v(" "),_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"download-frame"}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy"},[_c('h2',[_vm._v("Browser extensions")]),_vm._v(" "),_c('p',[_vm._v("Combine RememBear with the browser extension to autofill your logins and credit cards with one click")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"safari-notice"},[_c('p',[_c('strong',[_vm._v("Safari user?")])]),_vm._v(" "),_c('p',[_vm._v("RememBear for Safari is automatically installed with the Mac app.")]),_vm._v(" "),_c('p',{staticClass:"fine-print"},[_vm._v("Requirements: Safari Browser 11+ on macOS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vl9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_img_text_vue__ = __webpack_require__("Rt+q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627ae1d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_img_text_vue__ = __webpack_require__("gPr7");
function injectStyle (ssrContext) {
  __webpack_require__("sBY0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-627ae1d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_img_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627ae1d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_img_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_nav_nav__ = __webpack_require__("3Xzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer_footer__ = __webpack_require__("dQCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_meta_json__ = __webpack_require__("byxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_meta_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__data_meta_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_meta_js__ = __webpack_require__("i9Gr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_services_js__ = __webpack_require__("TZir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_js_cookie__);

//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_meta_js__["a" /* default */]],
  data: function data() {
    return {
      layout: {}
    };
  },

  components: {
    'nav-bar': __WEBPACK_IMPORTED_MODULE_1__components_nav_nav__["a" /* default */],
    'site-footer': __WEBPACK_IMPORTED_MODULE_2__components_footer_footer__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.$router.beforeEach(function (to, from, next) {
      _this.modifyLayout({});
      next();
    });
    this.doMeta();
    this.$router.afterEach(function (to, from) {
      _this.doMeta();
    });
    this.$http.interceptors.request.use(function (config) {
      var xsrf = __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get('XSRF-TOKEN');
      if (xsrf) {
        config.headers['RB-CSRF-Token'] = xsrf;
      }
      var formEncoded = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') > -1;
      var notFormData = !(config.data instanceof FormData);
      if (notFormData && formEncoded) {
        config.data = __WEBPACK_IMPORTED_MODULE_5__services_services_js__["a" /* default */].urlEncodeData(config.data);
      }
      return config;
    });
    this.$store.$http = this.$http;
    this.$store.ENV = this.ENV;
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('prepareUserData');
    }
    this.checkMKT();
  },
  methods: {
    checkMKT: function checkMKT() {
      if (__WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get('rb_mkt') || __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.get('TB_SESSION')) return;
      var query = location.search;
      if (query) {
        var params = Object.fromEntries(new URLSearchParams(query));
        if (params.cjevent) {
          params.trans_id = params.cjevent;
        }
        __WEBPACK_IMPORTED_MODULE_6_js_cookie___default.a.set('rb_mkt', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params), { expires: 60 * 60 * 24 * 1000 });
      }
    },
    doMeta: function doMeta() {
      if (__WEBPACK_IMPORTED_MODULE_3__data_meta_json___default.a[this.$route.name]) {
        this.applyMeta(__WEBPACK_IMPORTED_MODULE_3__data_meta_json___default.a[this.$route.name]);
      }
    },
    modifyLayout: function modifyLayout(modifier) {
      this.layout = {
        hideFooter: modifier.hideFooter || false,
        hideNav: modifier.hideNav || false,
        bgColor: modifier.bgColor || '',
        minimalNavigation: modifier.minimalNavigation || false
      };
    }
  }
});

/***/ }),

/***/ "zKIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("SFkb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394434f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("dioU");
function injectStyle (ssrContext) {
  __webpack_require__("cmBX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-394434f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_394434f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "za/q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/screenshots-ios.794a1b7.png";

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.60681736e86f4f2e6ac5.js